<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{path: '/product/product'}">商品管理</el-breadcrumb-item>
                <el-breadcrumb-item>积分商品编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    <div style="width: 100%;justify-content: center;display: flex;">
        <el-form class="user-search form-contain" :model="editForm" label-width="120px" inline label-position="left" style="width: 80%;" size="small">
            <el-form-item label="商品名称：">
                <el-input size="small" placeholder="请输入商品名称" v-model="editForm.goodsName">
                </el-input>
            </el-form-item>
            <el-form-item label="商品编号：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.goodsSn">
                </el-input>
            </el-form-item>
            <el-form-item label="所属类别：">
                <el-cascader v-model="value" :options="tableData"
                    :props="{ label: 'catename' , value: 'cateid'}" clearable
                    @change="cateSelect"
                   >
                </el-cascader>
            </el-form-item>
            <!-- relationRecommendGoods 关联商品 -->
            <el-transfer v-model="goodsvalue" :data="allGoodList"  
            :props="{  key: 'goodsId', label: 'goodsName' }"    @change="catetransfer"></el-transfer>
            <el-form-item label="卖点：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.sellPoint">
                </el-input>
            </el-form-item>

            <el-form-item label="库存：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.stock"></el-input>
            </el-form-item>
            <el-form-item label="虚拟库存：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.fictitiousStock">
                </el-input>
            </el-form-item>
            <el-form-item label="销量：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.saleNum"></el-input>
            </el-form-item>
            <el-form-item label="预计销量：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.initSaleNum">
                </el-input>
            </el-form-item>
            <div style="font-weight: 500;font-size: 20px;">价格设置</div>
            <el-form-item label="出售价格：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.salePrice">
                </el-input>
            </el-form-item>
            <el-form-item label="vip价格：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.vipPrice">
                </el-input>
            </el-form-item>
            <el-form-item label="vip价格：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.marketPrice">
                </el-input>
            </el-form-item>
            <el-form-item label="加购价格：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.addPrice">
                </el-input>
            </el-form-item>
            <el-form-item label="折扣：">
                <el-input size="small" placeholder="请输入订单编号" v-model="editForm.discount">
                </el-input>
            </el-form-item>
            <el-form-item label="上下架：">
                <el-select v-model="editForm.isSale" placeholder="默认全部">
                    <el-option label="下架" :value='0'></el-option>
                    <el-option label="上架" :value='1'></el-option>
                </el-select>

            </el-form-item>
            <el-form-item label="上架时间：">
                <!-- <el-input size="small" placeholder="请输入上架时间" v-model="editForm.presaleTime">
                </el-input> -->
                <datatime  v-model = "editForm.presaleTime" catename="presaleTime"></datatime>
            </el-form-item>
            <el-form-item label="促销商品：">
                <el-select v-model="editForm.isPromote" placeholder="否">
                    <el-option label="否" :value='0'></el-option>
                    <el-option label="是" :value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="限购数量：">
                <el-input size="small" placeholder="请填写限购数量" v-model="editForm.purchaseLimit">
                </el-input>
            </el-form-item>
            <div style="font-weight: 500;font-size: 20px;">图片管理</div>
            <!-- <div class="just-start marginT20">  </div> -->
                <!-- <div>首页主图：</div> -->
                <!-- <el-form-item label="首页主图：">    
                 <uploadone :url="editForm.mainImg"  cateName="mainImg"  @click="uploadone"></uploadone>
                </el-form-item> -->
          
            <el-form-item label="首页封面长图：长*宽:694*397">
                <uploadone :url="editForm.indexImg" cateName="indexImg" @click="uploadone"></uploadone>
              
            </el-form-item>
         
            <el-form-item label="商品主展示图：  长*宽:750*750"> 
                <uploadone :url="editForm.coverImg" cateName="coverImg" @click="uploadone"></uploadone>      
           </el-form-item>
   
            <!-- <div class="just-start marginT20">
                <div>视频主图：</div>
            </div> -->
            <el-form-item label="视频主展示图： 长*宽:750*750"> 
                <uploadone :url="editForm.videoImg" cateName="videoImg" @click="uploadone"></uploadone>  
              
            </el-form-item>
            <!-- <div class="just-start marginT20">
                <div>上传视频：</div> 
            </div> -->
            <el-form-item label="上传mp4视频： 长*宽:750*750">
                <uploadone :url="editForm.videoUrl" cateName="videoUrl" @click="uploadone" type="vedio" accept=".mp4,/vedio/mp4"></uploadone>  
               
            </el-form-item>
           <!-- <div style="display: flex;margin: 30px 0;"> -->
            <el-form-item label="详情页轮播图：长*宽:750*750"  style="width: 100%;">
                <!-- <div style="width: 150px;font-size: 24px;">上传轮播图：</div> -->
                <el-upload action="https://testm.chunpinkeji.com/api/uploadFileOss" list-type="picture-card"
                    class="upload-demo" multiple :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                    :on-success="handleSuccess" :limit="4" :file-list="fileList" :on-exceed="handleExceed">
                    <i class="el-icon-plus"></i>
                </el-upload>

               <el-dialog
      :close-on-click-modal="false" :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" v-if="dialogImageUrl">
                </el-dialog>
            </el-form-item>
           <!-- </div> -->
           
          
            <!-- <div class="just-start marginT20">
                <div>全屏图左：</div>
            </div> -->
            <el-form-item label="全屏图左：长*宽:694*364">
                <uploadone :url="editForm.fullScreenImg" cateName="fullScreenImg" @click="uploadone"></uploadone> 
              
            </el-form-item>    
           
            <!-- <div class="just-start marginT20">
                <div>全屏图右：</div>
            </div> -->
            <el-form-item label="全屏图右：长*宽:694*364">
                <uploadone :url="editForm.fullScreenImgRight" cateName="fullScreenImgRight" @click="uploadone"></uploadone> 
             
            </el-form-item>    
            
            <div style="font-weight: 500;font-size: 20px;">秒杀活动设置</div>
            <el-form-item label="商品顺序：">
                <el-input size="small" placeholder="秒杀商品排序" v-model="editForm.seckillIndex">
                </el-input>
            </el-form-item>
            <el-form-item label="开始时间：">
               
                <datatime v-model= "editForm.seckillStarttime" catename="seckillStarttime"></datatime>
             
            </el-form-item>
            <el-form-item label="持续时长：">
                <el-input size="small" placeholder="持续时间的长度" v-model="editForm.seckillCycle">
                </el-input>
            </el-form-item>
            <el-form-item label="场次：">
                <el-input size="small" placeholder="请输入场次" v-model="editForm.seckillSessions">
                </el-input>
            </el-form-item>
          
            <div style="font-weight: 500;font-size: 20px;">新品设置</div>
            <el-form-item label="新品顺序：">
                <el-input size="small" placeholder="新品排序" v-model="editForm.newIndex" >
                </el-input>
            </el-form-item>
           
                <quill-edit @content="getContent" :width="800" :height="800" :des="editForm.des"></quill-edit>
         
          

        </el-form>

   </div>
        <div class="footer">
            <el-button size="small" @click="closeDialog">返回</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitreplyForm">保存
            </el-button>
        </div>

    </div>
</template>

<script>
    import quillEdit from '../../components/quillEdit'
    import { addEditGoods,  getAllCategory ,getSaleGoods } from '../../api/basisMG.js'

    import datatime from '../../components/datatime'
    import uploadone from '../../components/uploadone'
    // 导出模块
    export default {
        components: {
            uploadone,
            quillEdit,
            datatime
        },
        // 模块数据
        data() {
            //数据  
            return {
                goodsvalue:[],
                allGoodList:[ ],
                value1:'',
                tableData:[],
                value:[],
                loading: false,
                Visible: false,
                fileList: [],
                dialogImageUrl:'',
                dialogVisible:false,
                editForm: {
                    goodsId: '',
                    goodstype: '',
                    goodsName: '',
                    des: '',
                    SelectValue: '',
                    goodsdes: '',
                    sellPoint: '',
                    specications: '',
                    price: null,
                    marketPrice: null,
                    stock: 999,
                    saleNum: 0,
                    purchaseLimit: 0,
                    day: '',
                    time: '',
                    imglunbo: '',
                    videoUrl: '',
                    videoImg: '',
                    mainImg: '',
                    indexImg: '',
                    freightFee: '',
                    cateId: null,
                    cateId2: null,
                    stockThresholdType: null,
                    stockThreshold: 100,
                    uploadData: [],
                    allGoodList:[]
                }
            }
        },


        watch: {},

        methods: {
             // 获得在售商品
      getGoods(){
        getSaleGoods().then(res=>{
          if(res.code=='200'){
            this.allGoodList = res.data
          }
        })
      },
            getdata(data,catename){
                this.editForm[catename] = data
                console.log(catename)
                console.log(this.editForm)
            },
            catetransfer( data){
                console.log(data)
                this.editForm.relationRecommendGoods= data.join(",")
            },
            cateSelect(data){
                console.log(data)
                let length = data.length
                this.editForm.cateId = data[length-2] 
                this.editForm.cateId2 = data[length-1] 
                console.log( this.editForm.cateId, this.editForm.cateId2)
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
              //  图片上传
              handleRemove(file, fileList) {
                // this.editForm.fileList = fileList
                this.fileList = fileList
                let arr = []
                this.fileList.forEach(item=>{
                    arr.push(item.response.data)
                })
                if(arr.length){
                    this.editForm.bannerImg = arr.join(",")
                }else{
                    this.editForm.bannerImg = ""
                }
                
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(response, file, fileList) {

                this.fileList = fileList
                let arr = []
                this.fileList.forEach(item=>{
                    arr.push(item.response.data)
                })
                console.log(arr)
                this.editForm.bannerImg = arr.join(",")
                this.dialogImageUrl = response.data


            },
            timeChange(time){
                this.editForm.seckillStarttime = time
                console.log(time)
            },
            submitreplyForm() {
                console.log(this.editForm)
                this.editForm.presaleTime = this.editForm.presaleTime/1000
                this.editForm.seckillStarttime = this.editForm.seckillStarttime/1000
                addEditGoods(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$router.push({path:'/product/product'})
                    }
                })
            },
           
            // 单个上传图
            uploadone(data, cateName){
                console.log(cateName)
                this.editForm[cateName] = data
            },
           
            getContent(content) {

                this.editForm.des = content
            },
            getCategory() {
                //   获得商品分类列表
                getAllCategory().then(res => {
                    if (res.code == '200') {
                        
                        // this.tableData = res.data
                        let formatData = this.formateChildren(res.data)
                        // cateid: 10
                        formatData.forEach(item=>{
                            if(item.cateid==10){
                             
                                this.tableData= item.children
                            }
                        })
                        // this.tableData = formatData

                    }

                })
            },
            formateChildren(data){
                if(data.length){
                    data.map(element => {
                        if(element.children && element.children.length>0){
                            this. formateChildren(element.children)
                        }else{
                            delete element.children
                        }
                    });
                }
                return data
            },

            // 评论框
            closeDialog() {
                this.$router.push({path:'/product/product'})


            },
            setStatus(row) {
                this.editForm.isSale = row.isSale == 1 ? 0 : 1
            },
         
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
          this.getGoods()
            this.getCategory()
        },
        // 挂载前状态(里面是操作)
        beforeMount() { 
            this.editForm = JSON.parse(this.$route.query.editForm)
            console.log('fileList',this.editForm)
            if(this.editForm.relationRecommendGoods){
                let goodsvalue = this.editForm.relationRecommendGoods.split(",")

                goodsvalue.forEach(item=>{
                    this.goodsvalue.push(Number(item)) 
                })
            }
            if(this.editForm.bannerImg){
              
                let fileList  = this.editForm.fileList
              
               fileList.forEach(item=>{
                   this.fileList.push(this.web.obj(item))
                })
            }
            if(this.editForm.cateId){
                this.value.push(Number(this.editForm.cateId))
            }
            if(this.editForm.cateId2){
                this.value.push(Number(this.editForm.cateId2))
            }
           
        },
        // 挂载结束状态(里面是操作)
        mounted() {
         console.log( JSON.parse(this.$route.query.editForm))
            // this.editForm = JSON.parse(this.$route.query.editForm)
         },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>


    .just-start {
        display: flex;
        justify-content: flex-start;
    }

    .marginT20 {
        margin-top: 20px;
    }
    .footer{
        margin: 100px auto;
       
        display: flex;
        justify-content: center;
    }
</style>